






























import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AddressItem from "wallet/components/address/AddressItem.vue";
import { Address } from "@foxone/api/src/models/wallet/mixin";
import mixins from "@/mixins";

@Component({
  components: {
    AddressItem
  }
})
class Addresses extends Mixins(mixins.page) {
  @Getter("wallet/mixin/getAssetById") getAssetById;

  addresses: Address[] = [];

  loading = false;

  get title() {
    return this.$t("common.addresses") as string;
  }

  get id() {
    return this.$route.params.id as string;
  }

  get asset() {
    return this.getAssetById(this.id);
  }

  mounted() {
    this.init();
  }

  async init() {
    this.loading = true;
    await this.requestAddresses();
    this.loading = false;
  }

  handleCreateAddress() {
    this.$helper.toFusionPath(this, "wallet", {
      name: "addresses-id-create",
      params: { id: this.id }
    });
  }

  handleRefresh() {
    this.init();
  }

  async requestAddresses() {
    try {
      const addresses = await this.$api.wallet.mixin.getAssetAddresses(this.id);
      this.addresses = addresses;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default Addresses;
